"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    name: 'WokButton',
    functional: true,
    props: {
        icon: {
            type: String,
            default: undefined
        },
        iconPosition: {
            type: String,
            default: 'right',
            validator: function (v) { return v == '' || /(right|left)/.test(v); }
        },
        kind: {
            type: String,
            default: 'primary',
            validator: function (v) { return v == '' || /(primary|secondary|tertiary|danger|ghost|tab)/.test(v); }
        },
        size: {
            type: String,
            default: 'default',
            validator: function (v) { return v == '' || /(default|field|small)/.test(v); }
        },
        variant: {
            type: String,
            default: undefined
        },
        disabled: {
            type: Boolean,
            default: false
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        tooltip: {
            type: String,
            default: undefined
        }
    },
    render: function (h, ctx) {
        return h(appropriateTag(ctx), {
            class: [buttonClasses(ctx), ctx.data.staticClass],
            attrs: __assign({ type: 'button', title: ctx.props.tooltip, disabled: ctx.props.disabled || ctx.props.isLoading }, ctx.data.attrs),
            on: ctx.listeners
        }, [
            ctx.slots().default && h('span', { class: 'wok--button__label' }, [
                ctx.slots().default
            ]),
            appropriateIcon(ctx) && h('i', { class: iconClasses(ctx) }, [
                h(appropriateIcon(ctx))
            ])
        ]);
    }
};
function appropriateTag(ctx) {
    if (ctx.data.attrs && ctx.data.attrs.to) {
        return 'router-link';
    }
    if (ctx.data.attrs && ctx.data.attrs.href) {
        return 'a';
    }
    return 'button';
}
function appropriateIcon(ctx) {
    if (ctx.props.isLoading) {
        return 'wok-icon-progress-16';
    }
    if (ctx.props.icon) {
        return ctx.props.icon;
    }
    return undefined;
}
function buttonClasses(ctx) {
    var classes = [
        'wok--button body-short-01',
        "wok--button--" + ctx.props.kind.toLowerCase(),
        "wok--button--" + ctx.props.size.toLowerCase(),
        "wok--button--icon-" + ctx.props.iconPosition.toLowerCase()
    ];
    if (ctx.props.isLoading) {
        classes.push('wok--button-is-loading');
    }
    if (ctx.props.variant) {
        classes.push("wok--button--" + ctx.props.variant);
    }
    if (!ctx.slots().default) {
        classes.push('wok--button--icon-only');
    }
    return classes;
}
function iconClasses(ctx) {
    return {
        'wok--button__icon': true,
        'wok--icon--is-spinning': ctx.props.isLoading
    };
}
